import axios from 'axios';

const accountStore = {
  namespaced: true,
  state: {
    expiry_policy: 0, // expiry policy is default to 0 (never expire)
    expiry_policy_options: [], // expiry policy options array
  },
  mutations: {
    /**
     * Set expiry policy options array
     * @param state
     * @param expiry_policy_options
     */
    setExpiryPolicyOptions(state, expiry_policy_options) {
      // eslint-disable-next-line no-param-reassign
      state.expiry_policy_options = expiry_policy_options;
    },
  },
  actions: {
    /**
     * Get expiry policy options array
     * @param commit
     * @returns {Promise<unknown>}
     * @constructor
     */
    async GET_EXPIRY_POLICY_OPTIONS({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('/api/v1/expiry-policy-options')
          .then(response => {
            commit('setExpiryPolicyOptions', response.data);
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
  },
  getters: {
    expiry_policy: state => state.expiry_policy,
    expiry_policy_options: state => state.expiry_policy_options,
  },
};

export default accountStore;
